import {INotification} from "@pg-design/notifications";

export const defaultAPIErrorNotification: Pick<INotification, "type" | "content"> = {
    type: "failure",
    content: "Coś poszło nie tak. Spróbuj później."
};

export const phoneErrorNotification: Pick<INotification, "type" | "content"> = {
    type: "failure",
    content: "Nieprawidłowy numer telefonu"
};
